import { ApolloError } from '@apollo/client'
import { Flow, Icon, Text, Tooltip } from 'bold-ui'
import { useAlert } from 'components/alert'
import { useErrorHandler } from 'components/error'
import { Form, FormRenderProps, SubmitButton } from 'components/form'
import { confirm } from 'components/modals/confirm'
import { useAlterarConfiguracaoDocumentosEnvioCidadaoMutation } from 'graphql/hooks.generated'

import { ASSINATURA_DIGITAL_INATIVA_MESSAGE } from '../model-assinaturaDigital'
import { ServicoAssinaturaDigitalCard } from './ServicoAssinaturaDigitalCard'

interface DocumentosEnvioCidadaoCardProps {
  habilitado: boolean
  baseHabilitada: boolean
  smtpConfigurado: boolean
}

export function DocumentosEnvioCidadaoCard(props: Readonly<DocumentosEnvioCidadaoCardProps>) {
  const { habilitado, baseHabilitada, smtpConfigurado } = props
  const alert = useAlert()
  const handleRejection = useErrorHandler()
  const [alterar] = useAlterarConfiguracaoDocumentosEnvioCidadaoMutation()
  const botaoDisabled = !baseHabilitada || !smtpConfigurado

  const submitAlteracao = async (msg: string) => {
    try {
      await alterar({ variables: { habilitado: !habilitado } })
      alert('success', msg)
    } catch (error) {
      handleRejection(error as ApolloError)
    }
  }

  const handleSubmit = async () => {
    if (habilitado) {
      const confirmed = await confirm({
        title: 'Deseja desabilitar o envio de documentos ao cidadão?',
        confirmLabel: 'Desabilitar',
      })()
      if (confirmed) await submitAlteracao('Envio de documentos ao cidadão desabilitado com sucesso.')
    } else {
      await submitAlteracao('Envio de documentos ao cidadão habilitado com sucesso.')
    }
  }

  const renderForm = (formProps: FormRenderProps) => (
    <ServicoAssinaturaDigitalCard
      habilitado={habilitado}
      titulo='Assinatura de documentos para envio ao cidadão'
      descricao={`Para habilitar o envio de prescrição e atestado digital, é necessário configurar um servidor SMTP na aba "Servidores".`}
    >
      <Flow direction='horizontal' alignItems='center'>
        <Tooltip text={!habilitado && !baseHabilitada ? ASSINATURA_DIGITAL_INATIVA_MESSAGE : ''}>
          <SubmitButton
            kind='primary'
            size='small'
            handleSubmit={formProps.handleSubmit}
            disabled={botaoDisabled || formProps.submitting}
          >
            {habilitado ? 'Desabilitar' : 'Habilitar'}
          </SubmitButton>
        </Tooltip>
        {!smtpConfigurado && (
          <Flow direction='horizontal' alignItems='center' gap={0.5}>
            <Icon icon='banOutline' fill='danger' size={1} />
            <Text color='danger'>Servidor SMTP desabilitado</Text>
          </Flow>
        )}
      </Flow>
    </ServicoAssinaturaDigitalCard>
  )

  return <Form onSubmit={handleSubmit} render={renderForm} />
}
